export default {
  DEV: 'http://88.209.69.126:9795',
  STAGING: 'http://88.209.69.126:9795',
  PRODUCTION: 'http://localhost:9795'
  // eslint-disable-next-line no-undef
}[process.env.REACT_APP_ENV || 'DEV'];
